var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "hb-section",
    {
      attrs: {
        title: _vm.$t("influencer_panel.tab_pix"),
        subtitle: _vm.$t("influencer_panel.pix_destinations"),
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", size: "sm" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("create")
                    },
                  },
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "PlusIcon", size: "14" },
                  }),
                  _vm._v(
                    " " + _vm._s(_vm.$t("influencer_panel.pix_register")) + " "
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      !_vm.keys.length
        ? _c("hb-empty-state", {
            attrs: {
              title: _vm.$t("influencer_panel.no_pix_keys"),
              icon: "KeyIcon",
            },
          })
        : _c(
            "div",
            [
              _vm._l(_vm.keys, function (key) {
                return _c("div", { key: key.id, staticClass: "pix__row" }, [
                  _c(
                    "span",
                    { staticClass: "pix__icon" },
                    [
                      _c("feather-icon", {
                        attrs: { icon: _vm.iconFor(key.key_type), size: "15" },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "pix__identity" }, [
                    _c(
                      "div",
                      { staticClass: "pix__value" },
                      [
                        _c("code", [_vm._v(_vm._s(key.masked_key))]),
                        key.is_default
                          ? _c(
                              "b-badge",
                              { attrs: { variant: "light-primary" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("influencer_panel.default_key")
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "pix__type" }, [
                      _vm._v(_vm._s(_vm.typeLabel(key.key_type))),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "pix__status" },
                    [
                      _c("hb-status-badge", {
                        attrs: { status: key.status, domain: "pix" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "pix__actions" },
                    [
                      !key.is_default && key.status === "VA"
                        ? _c(
                            "b-button",
                            {
                              attrs: { variant: "flat-primary", size: "sm" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("set-default", key)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("influencer_panel.pix_make_default")
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c("hb-icon-button", {
                        attrs: {
                          icon: "Trash2Icon",
                          tone: "danger",
                          label: _vm.$t("influencer_panel.pix_remove"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("remove", key)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ])
              }),
              _c(
                "p",
                { staticClass: "pix__note" },
                [
                  _c("feather-icon", {
                    attrs: { icon: "InfoIcon", size: "13" },
                  }),
                  _vm._v(
                    " " + _vm._s(_vm.$t("influencer_panel.pix_hint")) + " "
                  ),
                ],
                1
              ),
              _vm.hasUnvalidatedKey
                ? _c(
                    "p",
                    { staticClass: "pix__warning" },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "AlertTriangleIcon", size: "13" },
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "influencer_panel.pix_pending_validation_note"
                            )
                          ) +
                          " "
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }